module.exports = __webpack_public_path__ + "static/moreAccount180-cb26ff699135b5e9afbe6a02c6194da4.png";